export {
  default,
  BankDetailsFormDefaultValues,
  type IBankDetailsForm,
} from "./bankDetails";
